import { render, staticRenderFns } from "./JQueryChips.vue?vue&type=template&id=7dafac8e&"
import script from "./JQueryChips.vue?vue&type=script&lang=ts&"
export * from "./JQueryChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports